import * as React from "react";

function SvgIcons8Conference(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M16 4c-2.2 0-4 1.8-4 4 0 1.035.41 1.973 1.063 2.688-.407.199-.766.445-1.126.718C11.649 9.484 9.998 8 8 8c-2.2 0-4 1.8-4 4 0 1.066.434 2.031 1.125 2.75-.258.14-.516.293-.75.469A6.001 6.001 0 002 20h2c0-1.309.629-2.457 1.594-3.188A3.96 3.96 0 018 16c.621 0 1.203.168 1.75.438l1.094.53.312-1.187C11.703 13.617 13.652 12 16 12a4.984 4.984 0 014.844 3.75l.312 1.219 1.094-.563A3.92 3.92 0 0124 16c2.219 0 4 1.781 4 4h2c0-2.254-1.273-4.227-3.125-5.25A3.958 3.958 0 0028 12c0-2.2-1.8-4-4-4-1.996 0-3.648 1.484-3.938 3.406a6.784 6.784 0 00-1.125-.719A3.978 3.978 0 0020 8c0-2.2-1.8-4-4-4zm0 2c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2zm-8 4c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2zm16 0c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2zm-8 6c-2.2 0-4 1.8-4 4 0 1.066.434 2.031 1.125 2.75C11.273 23.773 10 25.746 10 28h2c0-2.219 1.781-4 4-4 2.219 0 4 1.781 4 4h2c0-2.254-1.273-4.227-3.125-5.25A3.958 3.958 0 0020 20c0-2.2-1.8-4-4-4zm0 2c1.117 0 2 .883 2 2s-.883 2-2 2-2-.883-2-2 .883-2 2-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Conference);
